/* Consented, value-free events. Shopify custom pixel owns the persisted client identity. */
(function () {
  'use strict';
  if (window.NLJourney) return;
  var allowed = false, seen = new Set(), last = new Map(), authorization = null, authorizing = null, generation = 0;
  var events = ['builder_viewed','builder_started','builder_tab_changed','design_changed','preview_view_changed',
    'required_data_complete','validation_error','cart_attempt','cart_success','cart_error','cart_viewed','checkout_clicked'];
  var values = {
    product:['aquarell','linie','mixed','unknown'], frame:['none','white','black','canvas','unknown'],
    target:['','design','data','live','example','name','length','date','nlStyle','nlLine','nlPose','nlSide','nlFrame','nlPaper'],
    code:['','required_or_invalid','unavailable','http_error','network_error','invalid_response']
  };
  function consent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed());
  }
  function authorize() {
    if (!consent()) return Promise.resolve(null);
    if (authorization && authorization.expires_at > Date.now() / 1000 + 60) return Promise.resolve(authorization);
    if (authorizing) return authorizing;
    var ownGeneration = generation;
    authorizing = fetch('/apps/natolino-events/context/', {method:'POST', credentials:'omit',
      headers:{'Content-Type':'text/plain'}, body:JSON.stringify({v:1,consent:true}), cache:'no-store'})
      .then(function (response) { if (!response.ok) throw new Error('context_unavailable'); return response.json(); })
      .then(function (value) {
        if (!consent() || generation !== ownGeneration) return null;
        if (value.v !== 1 || !/^[a-f0-9-]{36}$/.test(value.client || '') ||
            !/^[A-Za-z0-9_-]{1,300}\.[a-f0-9]{64}$/.test(value.token || '') ||
            !Number.isInteger(value.expires_at) || value.expires_at <= Date.now() / 1000) return null;
        authorization = value; return value;
      }).catch(function () { return null; });
    var pending = authorizing;
    pending.then(function () { if (authorizing === pending) authorizing = null; });
    return pending;
  }
  function publish(detail) {
    try {
      if (!consent() || events.indexOf(detail.event) < 0) return;
      var analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.publish !== 'function') return;
      var clean = {event:detail.event};
      Object.keys(values).forEach(function (key) {
        clean[key] = values[key].indexOf(detail[key]) >= 0 ? detail[key] : (key === 'target' || key === 'code' ? '' : 'unknown');
      });
      clean.test = !window.Shopify.theme || window.Shopify.theme.role !== 'main';
      var key = JSON.stringify(clean), now = Date.now();
      if ((detail.event === 'builder_viewed' || detail.event === 'cart_viewed') && seen.has(key)) return;
      if (last.has(key) && now - last.get(key) < 500) return;
      seen.add(key); last.set(key, now);
      var ownGeneration = generation;
      authorize().then(function (auth) {
        if (!auth || !consent() || ownGeneration !== generation) return;
        clean.authorization = auth;
        return analytics.publish('natolino:journey', clean);
      }).catch(function () {});
    } catch (ignored) { /* Analytics cannot block buying. */ }
  }
  function refresh() {
    try {
      var next = consent();
      if (!next) { seen.clear(); last.clear(); authorization = null; authorizing = null; generation += 1; }
      if (next && !allowed) {
        allowed = true;
        document.querySelectorAll('[data-nl-builder]').forEach(function (root) {
          root.dispatchEvent(new Event('nl:analytics-ready'));
        });
        if (document.querySelector('[data-nl-cart-preview]')) publish({event:'cart_viewed'});
      }
      allowed = next;
    } catch (ignored) { allowed = false; }
  }
  document.addEventListener('nl:journey', function (event) { publish(event.detail || {}); });
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('nl:consent', refresh);
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[name="checkout"]')) publish({event:'checkout_clicked'});
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.submitter && event.submitter.name === 'checkout') publish({event:'checkout_clicked'});
  }, true);
  window.NLJourney = Object.freeze({refresh:refresh});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
})();
